import Vue from 'vue'
import App from '@/App'
// api: https://github.com/vuejs/vue-router
import router from '@/router'
// api: https://github.com/vuejs/vuex
import store from '@/store'
// api: https://github.com/alfhen/vue-cookie
import VueCookie from 'vue-cookie'
// api: https://github.com/ElemeFE/element
import '@/element-ui'
// api: http://www.iconfont.cn/
import '@/icons'
import '@/element-ui-theme'
import '@/assets/scss/index.scss'
// api: https://github.com/axios/axios
import axios from 'axios'
import httpRequest from '@/utils/httpRequest'
import { isAuth, unitChange, getMonthLastDay, formatTime } from '@/utils'
import { replaceWord, isRMB } from './utils/replaceWord'

// 打印机
import Print from 'vue-print-nb'
// 复制黏贴
import VueClipboard from 'vue-clipboard2'

// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueClipboard)
Vue.use(VueQuillEditor)
Vue.use(Print)
Vue.use(VueCookie)
Vue.config.productionTip = false
// 挂载全局
// 根据当前月第一天时间获取最后一天的时间戳
Vue.prototype.getMonthLastDay = getMonthLastDay
// 全局替换字段
Vue.prototype.replaceWord = replaceWord
// 全局開關
Vue.prototype.switchs = parseInt(localStorage.getItem('switch'))
// 时间戳转字符串
Vue.prototype.formatTime = formatTime
// 切换人名币符号
Vue.prototype.isRMB = isRMB
// 价格单位转换
Vue.prototype.unitChange = unitChange
// ajax 请求方法
Vue.prototype.$http = httpRequest
// 权限方法
Vue.prototype.isAuth = isAuth
// axios 请求
Vue.prototype.axios = axios

Vue.prototype.laborProcessing = function (data) {
  if (!data) {
    return ''
  } else {
    let departmentName = ''
    data.forEach(item => {
      departmentName = departmentName + item.name + '\n'
    })
    return departmentName
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
